import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './AInsteinPage.css';

const termsHTML = `
  <div style="margin: 0; padding: 20px; font-family: system-ui, -apple-system, sans-serif; max-width: 800px; margin: 0 auto; line-height: 1.6;">
    <h1 style="font-size: 1.8rem; font-weight: 600; margin: 0 0 1rem 0; padding: 0; line-height: 1.2;">AInstein - Terms of Service</h1>
    <p style="margin: 0 0 2rem 0; color: #666;">Last Updated: June 21, 2025</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">1. Acceptance of Terms</h2>
    <p style="margin: 0 0 1.5rem 0;">At AInstein, we emphasize the importance of adhering to both legal and institutional regulations when recording and sharing content. We ask all users to follow these guidelines to ensure compliance with applicable policies and laws.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">2. Service Description</h2>
    <p style="margin: 0 0 1.5rem 0;">AInstein provides AI-powered learning assistance, including but not limited to generating study materials, answering questions, and providing educational support. The Service is intended for personal, non-commercial use.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">3. User Responsibilities</h2>
    <p style="margin: 0 0 1rem 0;">As a user of AInstein, you agree to:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Use the Service in compliance with all applicable laws and regulations</li>
      <li style="margin: 0 0 0.5rem 0;">Not use the Service to generate harmful, misleading, or illegal content</li>
      <li style="margin: 0 0 0.5rem 0;">Maintain the confidentiality of your account credentials</li>
      <li style="margin: 0;">Not attempt to reverse engineer, decompile, or hack the Service</li>
    </ul>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">4. Intellectual Property</h2>
    <p style="margin: 0 0 1.5rem 0;">All content generated by AInstein is provided for personal, non-commercial use only. You may not reproduce, distribute, or create derivative works without explicit permission.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">5. Subscription and Billing</h2>
    <p style="margin: 0 0 1rem 0;">AInstein may offer both free and paid subscription plans. For paid subscriptions:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Subscriptions are billed in advance on a recurring basis</li>
      <li style="margin: 0 0 0.5rem 0;">You may cancel your subscription at any time</li>
      <li style="margin: 0;">Refunds are subject to our Refund Policy (Section 7)</li>
    </ul>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">6. Termination</h2>
    <p style="margin: 0 0 1.5rem 0;">We reserve the right to suspend or terminate your access to the Service for violations of these Terms or for any other reason at our sole discretion.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">7. Refund Policy</h2>
    <h3 style="font-size: 1.1rem; font-weight: 600; margin: 1.5rem 0 0.75rem 0;">Eligibility</h3>
    <p style="margin: 0 0 1rem 0;">Refund requests will be considered under the following conditions:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Request made within 48 hours of subscription</li>
      <li style="margin: 0 0 0.5rem 0;">Technical issues that we cannot resolve within a reasonable time</li>
      <li style="margin: 0;">Duplicate or accidental charges</li>
    </ul>
    
    <h3 style="font-size: 1.1rem; font-weight: 600; margin: 1.5rem 0 0.75rem 0;">Non-Refundable</h3>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Subscription renewals</li>
      <li style="margin: 0 0 0.5rem 0;">Accounts terminated for Terms of Service violations</li>
      <li style="margin: 0;">Promotional or discounted subscriptions</li>
    </ul>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">8. Limitation of Liability</h2>
    <p style="margin: 0 0 1.5rem 0;">AInstein is provided "as is" without any warranties. We are not responsible for any direct, indirect, incidental, or consequential damages resulting from your use of the Service.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">9. Changes to Terms</h2>
    <p style="margin: 0 0 1.5rem 0;">We may update these Terms from time to time. We will notify users of significant changes through the Service or via email.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">10. Contact Us</h2>
    <p style="margin: 0 0 1.5rem 0;">For questions about these Terms, please contact us at <a href="mailto:pankaj6apr@outlook.com" style="color: #4f46e5; text-decoration: none; font-weight: 500;">pankaj6apr@outlook.com</a>.</p>
  </div>
`;

const TermsOfService: React.FC = () => {
  return (
    <div className="ainstein-app" style={{ paddingTop: '80px' }}>
      <Header />
      <main style={{ margin: '0 auto', maxWidth: '800px', padding: '0 1rem 2rem', lineHeight: '1.6', color: '#333', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <div style={{ lineHeight: '1.5' }} dangerouslySetInnerHTML={{ __html: termsHTML }} />
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
